import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';


function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

export default function FiltersBreadCrumbs() {
  const breadcrumbs = [
    
      <Link underline="hover" key="1" color="primary" href="/" onClick={handleClick} sx={{color: "#2B817B", fontSize: "14px", fontWeight: "400"}}>
      Home
    </Link>,
    
    <Link underline="hover" key="1" color="primary" href="/" onClick={handleClick} sx={{color: "#2B817B", fontSize: "14px", fontWeight: "400"}}>
      All Menu
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="primary"
      href="/material-ui/getting-started/installation/"
      onClick={handleClick}
      sx={{color: "#2B817B", fontSize: "14px", fontWeight: "400"}}
    >
      All Cuisine
    </Link>

  ];

  return (
    <Stack spacing={2}>

      <Breadcrumbs
      
        separator={<NavigateNextIcon fontSize="small" width="4.73px" height="10.56px" />}
        aria-label="breadcrumb"
        color="primary"
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
}
